(function ($) {
  $(document).ready(function() {
    if ($(".select2-container").length) {
      $("body").on("click", function(e) {
        $(".select2-selection").removeAttr("role");
        $(".select2-search__field").removeAttr("role");
        $(".select2-search__field").attr("aria-label", "textbox");
        $(".select2-search__field").attr("type", "text");
      });
    }
  });
})(jQuery);
